export function calculateAverageUserRating(ratings: any[]): number | null {
  if (!ratings || ratings.length === 0) {
    return null;
  }
  const validRatings = ratings.filter(
    (r) => r.rating !== null && r.rating !== undefined,
  );

  if (validRatings.length === 0) {
    return null;
  }

  const average =
    validRatings.reduce((total, obj) => total + obj.rating, 0) /
    validRatings.length;
  return parseFloat(average.toFixed(1));
}
